/**
 * Created by ashahab on 8/23/2017.
 */

import React, {Component} from "react";
import {connect} from "react-redux";
import {browserHistory} from "react-router";
import {Modal, Button} from "react-bootstrap";
import ElasticSearchStore from "../../../../actions/elastic-search-store";
import config from "../../../../config";
import apiClient from "../../../../actions/api-client";
import ProgressIndicator from "../../../progress-indicator/progress-indicator";
import "./widget.css";
import TextFieldGroup from "../../../forms/text-field-group";
import icon from "./Martz90-Circle-Addon1-Text-plus.ico";
class CreateNewAssignment extends Component {

    constructor(props) {
        super(props);
        this.estore = new ElasticSearchStore();
        this.headinText = props.headinText;
        this.submitCreateAssignmentDialog = this.submitCreateAssignmentDialog.bind(this);
        this.showIndicator = this.showIndicator.bind(this);
        this.hideIndicator = this.hideIndicator.bind(this);
        this.getActivityAssignDialog = this.getActivityAssignDialog.bind(this);
        this.assignActivity = this.assignActivity.bind(this);
        this.loadActivities = this.loadActivities.bind(this);
        this.searchActivities = this.searchActivities.bind(this);
        this.searchCourses = this.searchCourses.bind(this);

        this.state = {
            showAssignCourseDialog: false,
            showActivityAssignDialog: false,
            loading:false,

            searchActivityName:'',
            activitiesSearchResult:[],

            searchCourseName:'',
            coursesSearchResult:[]
        };
    }

    componentDidMount(){
        this.loadCourses();
        this.loadActivities();
    }

    showIndicator() {
        this.setState({
            ...this.state,
            loading: true
        });
    }

    hideIndicator() {
        this.setState({
            ...this.state,
            loading: false
        });
    }

    searchCourses(event)
    {
        let searchTerm = event.target.value.toLowerCase();
        let searchResult = [];
        let data = this.state.courses;
        if (searchTerm === "")
        {
            searchResult = data;
        }
        else
        {
            if (data.length >0)
            {
                for (let i = 0; i < data.length; i++)
                {
                    let tempVarName = data[i].courseName.toLowerCase();
                    if (tempVarName.search(searchTerm) !== -1) {
                        searchResult.push(data[i]);
                    }
                }
            }
        }
        this.setState({coursesSearchResult:searchResult, searchCourseName:searchTerm});
    }

    loadCourses() {
        return new Promise((resolve, reject) => {

            let context = this;
            let visibility = '(public OR "' + this.props.auth.user.userName + '"';
            if (this.props.auth.user.userType.toLowerCase() === "admin" && this.props.auth.user.schoolName === "LearnerPal") {
                visibility += " OR LPAdmin";
            }
            visibility += ')';
            let subjectsToSearch = "(";
            if (this.props.auth.user.subjects) {
                this.props.auth.user.subjects.forEach(sub => {
                    subjectsToSearch += "\"" + sub + "\" OR ";
                })
            }
            subjectsToSearch = subjectsToSearch.substring(0, subjectsToSearch.length - 3);
            let query = "visibleTo : " + visibility + " AND subject : " + subjectsToSearch + ")";
            this.estore.query(null, 'course' + config.stage, {
                "bool": {
                    "must": {
                        "query_string": {
                            "query": query
                        }
                    }
                }
            }, null, null, null, null, null).then((filterData) => {

                context.setState({
                    courses: filterData.data,
                    coursesSearchResult:filterData.data
                });
                resolve(filterData.data);
            }).catch(error=> {
                context.setState({
                    showAlert: true,
                    alertStyle: 'danger',
                    alertText: 'Unable to perform search, please contact administrator.',
                    loading: false
                });
                setTimeout(()=> {
                    context.setState({
                        showAlert: false,
                        alertStyle: '',
                        alertText: ''
                    })
                }, 4000);
                reject(error);
            })
        })
    }

    loadActivities() {
        return new Promise((resolve, reject) => {

            let context = this;
            let visibility = '(public OR "' + this.props.auth.user.userName + '"';
            if (this.props.auth.user.userType.toLowerCase() === "admin" && this.props.auth.user.schoolName === "LearnerPal") {
                visibility += " OR LPAdmin";
            }
            visibility += ')';
            let subjectsToSearch = "(";
            if (this.props.auth.user.subjects) {
                this.props.auth.user.subjects.forEach(sub => {
                    subjectsToSearch += "\"" + sub + "\" OR ";
                })
            }
            subjectsToSearch = subjectsToSearch.substring(0, subjectsToSearch.length - 3);
            let query = "visibleTo : " + visibility + " AND subjects : " + subjectsToSearch + ")";
            this.estore.query(null, 'activity' + config.stage, {
                "bool": {
                    "must": {
                        "query_string": {
                            "query": query
                        }
                    }
                }
            }, [
                'id',
                'name',
                'subjects',
                'ownerName',
                'activityType'
            ], null, null, null, null).then((filterData) => {

                context.setState({
                    activities: filterData.data,
                    activitiesSearchResult:filterData.data
                });
                resolve(filterData.data);
            }).catch(error=> {
                context.setState({
                    showAlert: true,
                    alertStyle: 'danger',
                    alertText: 'Unable to perform search, please contact administrator.',
                    loading: false
                });
                setTimeout(()=> {
                    context.setState({
                        showAlert: false,
                        alertStyle: '',
                        alertText: ''
                    })
                }, 4000);
                reject(error);
            })
        })
    }

    submitCreateAssignmentDialog(event)
    {
        switch (event.target.id)
        {
            case 'course':
                this.setState({
                    showAssignCourseDialog:true
                });
                break;
            case 'activity':
                //browserHistory.push({pathname: 'assignments/activities', state: {isFromAssignmentToAssignActivity:true}});
                this.setState({
                    showActivityAssignDialog:true
                });
                break;
            case 'newActivity':
                browserHistory.push({pathname: 'assignments/activities', state: {isFromAssignment:true,showCreateEditDialog:true}});
                break;
        }

    }

    render() {
        return (
            <div  className="dasboxss col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{marginBottom:'0px', paddingBottom:'0px'}}>
                <div  className="col-lg-12 col-md-12 col-sm-12 col-xs-12  pacboxdes" style={{marginBottom:'0px' }}>
                    <div>
                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12  ">
                            <div className="icondes">
                                <div className="limitFiltersas">
                                    <img src={icon} style={{height: '45px'}}/>
                                    {/*<span className="typeIconsorn minnine"/>*/}
                                </div>
                            </div>
                            <div className="icondeshead">
                                <a className="boardheadblf noHover">Create New Assignment</a>
                            </div>
                        </div>
                        < div  className="brdrds"/>
                    </div>
                    <div className="dashboardWidgetContainer">
                        <div className="row" style={{padding: '10px 0', marginLeft: '0px', marginRight: '0px', borderBottom: '1px solid #ccc' }}>
                            <div className="icondeshead" style={{width:'65%'}}>
                                <a className="boardhead" style={{margin: '10px', marginLeft: '28px', color:'#333'}}>Assign a course, or activities within a course</a>
                            </div>
                            <div className="icondesheadsel" style={{marginTop: '7px',textAlign: 'left'}}>
                                <a style={{margin: '-10px'}} className="dashboardCreateAssignmentBtn" onClick={this.submitCreateAssignmentDialog} id="course">Get Started</a>
                            </div>
                        </div>
                        <div className="row" style={{padding: '10px 0', marginLeft: '0px', marginRight: '0px', borderBottom: '1px solid #ccc' }}>
                            <div className="icondeshead" style={{width:'60%'}}>
                                <a className="boardhead" style={{margin: '10px', marginLeft: '28px', color:'#333'}}>Assign an activity from activity listing</a>
                            </div>
                            <div className="icondesheadsel" style={{marginTop: '7px',textAlign: 'left'}}>
                                <a style={{margin: '-10px'}} className="dashboardCreateAssignmentBtn" onClick={this.submitCreateAssignmentDialog} id="activity">Get Started</a>
                            </div>
                        </div>
                        <div className="row" style={{padding: '10px 0', marginLeft: '0px', marginRight: '0px'}}>
                            <div className="icondeshead" style={{width:'60%'}}>
                                <a className="boardhead" style={{margin: '10px', marginLeft: '28px', color:'#333'}}>Create a new activity and assign</a>
                            </div>
                            <div className="icondesheadsel" style={{marginTop: '7px',textAlign: 'left'}}>
                                <a style={{margin: '-10px'}} className="dashboardCreateAssignmentBtn" onClick={this.submitCreateAssignmentDialog} id="newActivity">Get Started</a>
                            </div>
                        </div>
                        <div className="row"/>
                    </div>
                </div>
                {this.state.showAssignCourseDialog && this.getAssignDialog()}
                {this.state.showActivityAssignDialog && this.getActivityAssignDialog()}
                <ProgressIndicator show={this.state.loading}/>
            </div>
        );
    }

    assign(course){

        this.showIndicator();
        let that = this;
        apiClient.invokeApi({courseID: course.id},'/course/{courseID}','GET',{},{}).then(function (result) {
            that.hideIndicator();
            browserHistory.push({
                pathname: '/assignments/assign',
                state: {isCourseAssignment: true, course: result.data, isCourseLoaded: true, view:'course'}
            });
        });
    }

    assignActivity(activity) {

        this.showIndicator();
        let that = this;
        apiClient.invokeApi({activityID: activity.id}, '/activity/{activityID}', 'GET', {}, {}).then(function (result) {
            that.hideIndicator();
            browserHistory.push({
                pathname: '/assignments/assign',
                state: {currentActivityObj: result.data, currentActivity: activity.id, view: 'activity'}
            });
        });
    }

    getAssignDialog()
    {

        let courses = this.state.coursesSearchResult;
        let rows = null;
        let rowCount = 0;

        courses.forEach(row => {
            switch (row.subject && row.subject.toLowerCase()) {
                case 'algebra 1':
                case 'algebra':
                    row.className = 'subAlgebra';
                    break;
                case 'u.s. history and government':
                case 'us history':
                case 'u.s. history':
                    row.className = 'subUSHistory';
                    break;
                case 'global history and geography':
                    row.className = 'subGlobHistory';
                    break;
                case 'cc geometry':
                    row.className = 'subGeometry';
                    break;
                case 'earth science':
                    row.className = 'subErthSci';
                    break;
                case 'living environment':
                    row.className = 'subLivEnvi';
                    break;
                default:

                    break;
            }
        });

        if (courses) {
            rows = courses.map(course => {
                rowCount++;
                return <tr  id={"row-" + rowCount} key={"row-" + rowCount}>
                    <td>
                        <div className="icondes">
                            <div className="limitFiltersas">
                                <span className={course.className}/>
                            </div>
                        </div>
                        <div className="icondeshead">
                            <a className="boardhead" >{course.courseName}</a>
                            <a className="boardheadgrey" >By <strong>{course.ownerName}</strong></a>
                        </div>
                    </td>
                    <td>
                        <div title={course.subject}>{course.subject}</div>
                    </td>
                    <td>
                        <div className="tableActions">
                            <a href="javascript:void 0" onClick={function () {
                                this.assign(course);
                            }.bind(this)
                            }>Select</a>
                        </div>
                    </td>
                </tr>;
            })
        }
        let table = <table className="table table-hover hidden-xs">
            <thead>
            <tr>
                <th>
                    Course Name
                </th>
                <th>
                    Subject
                </th>
                <th></th>
            </tr>
            </thead>
            <tbody>
            {rows}
            </tbody>
        </table>;

        return <Modal id="assign-dialog"
                      backdrop="static"
                      show={this.state.showAssignCourseDialog}
                      onHide={()=> {
                          this.setState({showAssignCourseDialog: false});
                      }}
                      container={this}
                      aria-labelledby="contained-modal-title">
            <Modal.Header closeButton>
                <Modal.Title id="delete-activity-modal">Assign</Modal.Title>
                <br/>
                <br/>
                <h5>Select course to assign. You can assign entire course or activities within the course.</h5>
            </Modal.Header>
            <Modal.Body>
                <div id="assign-content">
                    <TextFieldGroup
                        value={this.state.searchCourseName}
                        id ="searchTextBoxCourse"
                        isDisabled={false}
                        field="searchCourses"
                        placeholder="Search Courses"
                        onChange={this.searchCourses}
                    />
                    {table}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={()=> {
                    this.setState({showAssignCourseDialog: false});
                }}>Close</Button>
            </Modal.Footer>
        </Modal>
    }

    searchActivities(event)
    {
        let searchTerm = event.target.value.toLowerCase();
        let searchResult = [];
        let data = this.state.activities;
        if (searchTerm === "")
        {
            searchResult = data;
        }
        else
        {
            if (data.length >0)
            {
                for (let i = 0; i < data.length; i++)
                {
                    let tempVarName = data[i].name.toLowerCase();
                    if (tempVarName.search(searchTerm) !== -1) {
                        searchResult.push(data[i]);
                    }
                }
            }
        }
        this.setState({activitiesSearchResult:searchResult, searchActivityName:searchTerm});
    }

    getActivityAssignDialog() {

        let activities = this.state.activitiesSearchResult;
        let rows = null;
        let rowCount = 0;
        for (let q=0; q< activities.length; q++)
        {

            if (activities[q].activityType)
            {
                switch (activities[q].activityType.toLowerCase()) {
                    case 'learning':
                        activities[q].className = 'learning';
                        break;
                    case 'flashcards':
                    case 'flashcard':
                        activities[q].className = 'flashCard';
                        break;
                    case 'question':
                        activities[q].className = 'questionRow';
                        break;
                    default:
                        activities[q].className = 'learning';
                        break;
                }
            }
        }
        if (activities) {

            rows = activities.map(activity => {
                rowCount++;
                return <tr id={"row-" + rowCount} key={"row-" + rowCount}>
                    <td>
                        <div className="icondes">
                            <div className="limitFiltersas">
                                <span className={activity.className}/>
                            </div>
                        </div>
                        <div className="icondeshead">
                            <a className="boardhead" >{activity.name}</a>
                            <a className="boardheadgrey" >By <strong>{activity.ownerName}</strong></a>
                        </div>

                    </td>
                    <td>
                        <div title={activity.subjects.toString()}>{activity.subjects.toString()}</div>
                    </td>
                    <td>
                        <div className="tableActions">
                            <a href="javascript:void 0" onClick={function () {
                                this.assignActivity(activity);
                            }.bind(this)
                            }>Assign</a>
                        </div>
                    </td>
                </tr>;
            })
        }
        let table = <table className="table table-hover hidden-xs">
            <thead>
            <tr>
                <th>
                    Activity Name
                </th>
                <th>
                    Subject
                </th>
                <th></th>
            </tr>
            </thead>
            <tbody>
            {rows}
            </tbody>
        </table>;

        return <Modal id="assign-dialog"
                      backdrop="static"
                      show={this.state.showActivityAssignDialog}
                      onHide={()=> {
                          this.setState({showActivityAssignDialog: false});
                      }}
                      container={this}
                      aria-labelledby="contained-modal-title">
            <Modal.Header closeButton>
                <Modal.Title id="delete-activity-modal">Assign</Modal.Title>
                <br/>
                <br/>
                <h5>You can select activity to assign here, or  if you need to see activity details prior to assigning, you can assign activities from the <a href="/activities">Activity Tab</a></h5>
            </Modal.Header>
            <Modal.Body>
                <div id="assign-content">
                    <TextFieldGroup
                        value={this.state.searchActivityName}
                        id ="searchTextBoxActivity"
                        isDisabled={false}
                        field="searchAcitivities"
                        placeholder="Search Activities"
                        onChange={this.searchActivities}
                    />
                    {table}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={()=> {
                    this.setState({showActivityAssignDialog: false});
                }}>Close</Button>
            </Modal.Footer>
        </Modal>
    }
}


function mapStateToProps(state = {}) {
    return {...state};
}

export default connect(mapStateToProps)(CreateNewAssignment);
